// Kept apart from queries.js, which imports onwardClient (and so firebase/auth): hooks.js loads this
// file, and columns.js loads hooks.js across the app, so Firebase here breaks unrelated Jest suites.
import { gql } from '@apollo/client';

// Bins and pools that hold freight for the orders this page shows, for the Bin/Pool Location
// filter's options. Read from the pallets themselves rather than the warehouse rack setup, which
// doesn't always spell bins the way pallets store them, and which a shipper can't see for an
// agent's warehouse. `$where` comes from binLocationOptionsWhere.
export const QUERY_OMS_BIN_LOCATIONS = gql`
    query OmsBinLocations($where: pallet_items_bool_exp!) {
        pallet_items(
            distinct_on: [warehouse_location, warehouse_id]
            order_by: [{ warehouse_location: asc }, { warehouse_id: asc }]
            where: $where
        ) {
            pallet_id
            warehouse_id
            warehouse_location
            warehouse {
                location_id
                location_name
            }
        }
    }
`;

// Turns an item barcode, a scanned label, or a bin/pool into order ids before the orders query runs.
// Every lookup reads items, one row per order, so `$limit` counts orders and a capped search returns
// the same orders on every run. Search lookups pass SEARCH_LOOKUP_LIMIT; exact filters (a scan,
// picked bins) pass null, which Hasura reads as no limit, so no order in a bin is left out.
export const QUERY_OMS_ORDER_IDS = gql`
    query OmsOrderIds($where: items_bool_exp!, $limit: Int) {
        items(where: $where, distinct_on: order_id, order_by: { order_id: asc }, limit: $limit) {
            item_id
            order_id
        }
    }
`;
